module.exports = __webpack_public_path__ + "img/default.016563ed.png";